import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { CompanyLogo } from 'src/components/placementDrives/shared';

interface OpportunitiesCardTitleProps {
	companyImg: string;
	companyName: string;
	positionTitle: string;
	companyUrl: string;
}

const OpportunitiesCardTitle: React.FC<OpportunitiesCardTitleProps> = ({ companyImg, companyName, positionTitle, companyUrl }) => (
	<div className="flex items-center gap-3.5">
		<CompanyLogo name={companyName} logo={companyImg} url={companyUrl} size={52} />
		<div className="min-w-0">
			<h6 className="text-[17px] leading-[24px] font-[800] tracking-[-0.015em] text-[#111E2C]">{positionTitle}</h6>
			<a
				target="_blank"
				rel="noreferrer"
				href={companyUrl}
				className="mt-0.5 flex items-center gap-1.5 text-[14px] leading-[20px] text-[#555770] hover:text-[#111E2C]"
			>
				<span className="truncate">{companyName}</span>
				{companyUrl ? <HiOutlineExternalLink className="h-4 w-4 shrink-0 text-[#4F46E5]" /> : null}
			</a>
		</div>
	</div>
);

export default OpportunitiesCardTitle;
